<!-- Floating Action Button -->
<button
  nz-button
  nzType="primary"
  nzSize="large"
  nzShape="circle"
  class="feedback-floating-button"
  (click)="showModal()"
  nz-tooltip
  nzTooltipTitle="Reportar bug o enviar feedback"
  nzTooltipPlacement="left"
>
  <span nz-icon nzType="message" nzTheme="outline"></span>
</button>

<!-- Feedback Modal -->
<nz-modal
  [(nzVisible)]="isModalVisible"
  nzTitle="Reportar Bug o Feedback"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  nzWidth="600px"
>
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="feedbackForm" nzLayout="vertical">
      <!-- Type Selection -->
      <nz-form-item>
        <nz-form-label nzRequired>Tipo</nz-form-label>
        <nz-form-control nzErrorTip="Por favor selecciona un tipo">
          <nz-radio-group formControlName="type">
            <label
              *ngFor="let type of feedbackTypes"
              nz-radio-button
              [nzValue]="type.value"
            >
              <span nz-icon [nzType]="type.icon" nzTheme="outline"></span>
              {{ type.label }}
            </label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>

      <!-- Title -->
      <nz-form-item>
        <nz-form-label nzRequired>Título</nz-form-label>
        <nz-form-control nzErrorTip="Por favor ingresa un título (máx. 255 caracteres)">
          <input
            nz-input
            formControlName="title"
            placeholder="Breve descripción del problema o sugerencia"
            maxlength="255"
          />
        </nz-form-control>
      </nz-form-item>

      <!-- Description -->
      <nz-form-item>
        <nz-form-label nzRequired>Descripción</nz-form-label>
        <nz-form-control nzErrorTip="Por favor describe el problema o sugerencia">
          <textarea
            nz-input
            formControlName="description"
            placeholder="Describe detalladamente el bug o tu sugerencia. Incluye pasos para reproducir si es un bug."
            [nzAutosize]="{ minRows: 4, maxRows: 8 }"
            maxlength="5000"
          ></textarea>
          <small class="character-count">
            {{ feedbackForm.get('description')?.value?.length || 0 }} / 5000
          </small>
        </nz-form-control>
      </nz-form-item>

      <!-- Priority -->
      <nz-form-item>
        <nz-form-label>Prioridad</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="priority" nzPlaceHolder="Selecciona la prioridad">
            <nz-option
              *ngFor="let priority of priorities"
              [nzLabel]="priority.label"
              [nzValue]="priority.value"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-alert
        nzType="info"
        nzMessage="Tu feedback será revisado por el equipo de administración"
        nzShowIcon
      ></nz-alert>
    </form>
  </ng-container>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()" [disabled]="submitting">
      Cancelar
    </button>
    <button
      nz-button
      nzType="primary"
      (click)="handleSubmit()"
      [nzLoading]="submitting"
    >
      Enviar
    </button>
  </ng-template>
</nz-modal>
